import { createErrorWithType } from '@apiEnabler/api-enabler-common/lib/errors'
import { switchMap } from 'rxjs/operators'
import { throwError, zip } from 'rxjs'
import { clientId$ } from '@apiEnabler/ob-common/lib/client-id'

import { brand$ } from './brand'
import { isStaffMember$ } from './staff'

export const failIfEbankingUnauthenticated = error => {
  if (error.type !== 'missing-access-token') throw error

  return zip(clientId$, brand$, isStaffMember$).pipe(
    switchMap(toEbankingBackstopIfNeeded)
  )

  function toEbankingBackstopIfNeeded([clientId, brand, isStaffMember]) {
    if (isStaffMember) throw error

    return throwError(
      brand.get('ssoEnabled') && clientId === process.env.REACT_APP_CLIENT_ID
        ? createErrorWithType(
            'Cannot log in Ebanking users directly',
            'ebanking-backstop'
          )
        : error
    )
  }
}
